import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const subtitleRef = useRef<HTMLParagraphElement>(null);
  const taglineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const els = [taglineRef.current, titleRef.current, subtitleRef.current];
    els.forEach((el, i) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      setTimeout(() => {
        if (!el) return;
        el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 200 + i * 180);
    });
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/e34d61433db0312211a1407289d46013.jpg)',
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-dark/90 via-brand-DEFAULT/80 to-black/85" />

      {/* Decorative grid lines */}
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
        <div className="max-w-3xl">
          <div ref={taglineRef} className="flex items-center gap-3 mb-8">
            <span className="w-10 h-px bg-brand-muted" />
            <span className="text-brand-muted text-xs font-medium tracking-[0.25em] uppercase">
              iOS Application Development
            </span>
          </div>

          <h1 ref={titleRef} className="font-serif text-white mb-8" style={{ fontSize: 'clamp(40px, 5vw, 68px)', lineHeight: '1.1', fontWeight: 700 }}>
            Modern Applications<br />
            for a <em className="not-italic text-brand-muted">Secure</em> Mobile<br />
            Experience
          </h1>

          <p ref={subtitleRef} className="text-white/65 text-lg font-sans font-light leading-relaxed max-w-xl">
            VALDESTA OOD is a team of experts developing modern applications
            for the iOS platform. Our products are designed to enhance user
            experience and improve the security of mobile devices.
          </p>

          {/* Metrics strip */}
          <div className="mt-16 flex items-center gap-12 pt-10 border-t border-white/10">
            <div>
              <p className="text-white font-serif text-4xl font-semibold" style={{ lineHeight: 1 }}>iOS</p>
              <p className="text-white/45 text-xs tracking-widest uppercase mt-2">Platform</p>
            </div>
            <div className="w-px h-10 bg-white/10" />
            <div>
              <p className="text-white font-serif text-4xl font-semibold" style={{ lineHeight: 1 }}>100%</p>
              <p className="text-white/45 text-xs tracking-widest uppercase mt-2">Focus on quality</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="text-white/40 text-xs tracking-[0.2em] uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/40 to-transparent animate-pulse" />
      </div>
    </section>
  );
}
